import { Component, type ErrorInfo, type ReactNode } from 'react';

/**
 * Záchytná síť: neočekávaná chyba v zobrazení nesmí nechat černou obrazovku (na telefonu by to
 * znamenalo ztrátu tlačítka). Čekající markery jsou v IndexedDB a po obnovení se odešlou.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error): { error: Error } {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Chyba v zobrazení', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <div className="center-page" role="alert">
        <h1>Něco se pokazilo</h1>
        <p className="muted">
          Už uložené markery jsou v bezpečí, ty čekající se odešlou po obnovení stránky.
        </p>
        <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
          Načíst znovu
        </button>
      </div>
    );
  }
}
